import React from 'react'

// Components
import BaseSignUpView, { BaseSignUpViewProps } from './BaseSignUpView'
import RoleSpecificSignUpView from './RoleSpecificSignUpView'
import { LoadingState } from '@sketch/components'

// GraphQL
import { useGetCampaignSignUpContentQuery } from '@sketch/gql-types'
import { IndexLayoutExtraProps } from '@sketch/modules-common'

interface CampaignSpecificSignUpViewProps
  extends OmitSafe<BaseSignUpViewProps, 'content'>,
    Pick<IndexLayoutExtraProps, 'useOverrideLayoutProps'> {
  campaign: string
}

const CampaignSpecificSignUpView: React.FC<CampaignSpecificSignUpViewProps> = ({
  campaign,
  ...props
}) => {
  const { data, loading, error } = useGetCampaignSignUpContentQuery({
    variables: { campaign },
  })

  if (loading) {
    return <LoadingState />
  }

  if (error || !data?.campaignSignUpContent?.active) {
    // Fall back to showing the role-based sign up page if:
    // - there is an error loading the campaign data
    // - there is no such campaign
    // - the campaign exists but is inactive
    return <RoleSpecificSignUpView {...props} />
  }

  const { content } = data.campaignSignUpContent
  return <BaseSignUpView content={content} {...props} />
}

export default CampaignSpecificSignUpView
